import { useState, useEffect, useCallback } from "react";
import "./PatientsData.scss";
import { Content } from "antd/es/layout/layout";
import { theme, Pagination, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { SignIn } from "../../../../modals";
import { upvotePatient } from "../../../../features/patients/patientsActions";
import { PatientsDataContent, PatientsDataHeader } from "./components";
import { resetPatientsError } from "../../../../features/patients/patientsSlice";
import useStep1 from "../../../../hooks/useStep1";

export default function PatientsData({ searchVal, setSearchVal }) {
  const { useToken } = theme;
  const { token } = useToken();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (type, title, text) => {
      api[type]({
        message: title,
        description: text,
        placement: "top",
      });
    },
    [api]
  );
  const [searchParams] = useSearchParams();
  const { isAuthenticated, user } = useSelector((state) => state?.auth);
  const {
    patientsData: { meta },
    loading,
    error,
  } = useSelector((state) => state?.patients);
  const dispatch = useDispatch();
  const {
    onSearch,
    setUrlSearchParams,
    is_search_limit_reached,
    width,
    isMobile,
  } = useStep1(searchVal, setSearchVal);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [is_detail_opened, set_is_detail_opened] = useState(false);
  const [is_create_patient_opened, set_is_create_patient_opened] =
    useState(false);
  const [is_signin_opened, set_is_signin_opened] = useState(false);

  const onsegmentChange = (val) => {
    setUrlSearchParams({
      category: val ? val : undefined,
      own_only: searchParams?.get("own_only") || undefined,
      page: 1,
      per_page: 10,
      search: searchParams?.get("search")
        ? searchParams?.get("search")
        : searchVal
        ? searchVal
        : undefined,
    });
    if (searchVal) {
      onSearch(searchVal, true);
    }
  };

  const onCheckboxChange = (e) => {
    setUrlSearchParams({
      category: searchParams?.get("category") || undefined,
      own_only: e.target.checked ? "true" : undefined,
      page: 1,
      per_page: 10,
      search: searchParams?.get("search")
        ? searchParams?.get("search")
        : searchVal
        ? searchVal
        : undefined,
    });
    if (searchVal) {
      onSearch(searchVal, true);
    }
  };

  const handlePagination = (e, a) => {
    setUrlSearchParams({
      page: e,
      per_page: a,
      search: searchParams?.get("search") || undefined,
      category: searchParams?.get("category") || undefined,
      own_only: searchParams?.get("own_only") || undefined,
    });
  };

  const onListItemClick = (patient) => {
    if (!isAuthenticated) {
      set_is_signin_opened(true);
    } else {
      setSelectedPatient(patient);
      set_is_detail_opened(true);
    }
  };

  const handlePatientUpvote = (patient) => {
    if (!isAuthenticated) {
      set_is_signin_opened(true);
    } else if (isAuthenticated && !user?.is_organization) {
      openNotificationWithIcon(
        "warning",
        "Warning",
        "Only organizations can upvote patient."
      );
    } else {
      dispatch(
        upvotePatient({
          reported_user: patient?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (!is_detail_opened && !is_create_patient_opened) {
      if (error && !loading) {
        if (typeof error === "object" && !Array.isArray(error)) {
          for (let key in error) {
            if (typeof key === "string" && typeof error[key] === "string") {
              openNotificationWithIcon("error", "Error", error[key]);
              break;
            }
          }
        } else {
          openNotificationWithIcon("error", "Error", "Something went wrong !");
        }
        dispatch(resetPatientsError());
      }
    }
  }, [
    error,
    loading,
    openNotificationWithIcon,
    dispatch,
    is_detail_opened,
    is_create_patient_opened,
  ]);

  return (
    <>
      {contextHolder}
      <Content className="patientData-cont">
        <PatientsDataHeader
          token={token}
          isMobile={isMobile}
          is_search_limit_reached={is_search_limit_reached}
          user={user}
          isAuthenticated={isAuthenticated}
          onsegmentChange={onsegmentChange}
          onCheckboxChange={onCheckboxChange}
          searchParams={searchParams}
          is_create_patient_opened={is_create_patient_opened}
          set_is_create_patient_opened={set_is_create_patient_opened}
          openNotificationWithIcon={openNotificationWithIcon}
        />
        <PatientsDataContent
          token={token}
          onListItemClick={onListItemClick}
          handlePatientUpvote={handlePatientUpvote}
          selectedPatient={selectedPatient}
          setSelectedPatient={setSelectedPatient}
          is_detail_opened={is_detail_opened}
          set_is_detail_opened={set_is_detail_opened}
        />
        {meta?.count > 10 ? (
          <Pagination
            className="patientData-cont__pagination"
            align="end"
            pageSize={searchParams?.get("per_page") || 10}
            current={searchParams?.get("page") || 1}
            defaultCurrent={1}
            total={meta?.count}
            responsive={true}
            onChange={handlePagination}
            showQuickJumper={width < 584 && width >= 577 ? false : true}
            disabled={is_search_limit_reached}
          />
        ) : null}
        <SignIn
          token={token}
          isOpened={is_signin_opened}
          onCancel={() => {
            set_is_signin_opened(false);
          }}
        />
      </Content>
    </>
  );
}
